import React from 'react'
import { faPrint, faTrash } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  DcTabs,
  DcTag,
  PixelCurrency,
  PixelDate,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/internal/ajax/AjaxResponse'
import {
  del,
  getCourierPartnerPayments,
  getCourierPayments,
  getGeneralCourierList,
} from 'utils/api-routes.util'

import PaymentInvoicesDetail from './components/PaymentInvoicesDetail'
import UploadPaymentInvoice from './components/UploadPaymentInvoice'
import { Courier, IPixelFactory, IWeeklyPayment } from '../../../../decl.d'
import UploadIcon from '../../../utils/icons/upload-icon'
interface IResponse {
  error?: string
  message?: boolean
}
const UploadPayments = () => {
  const [tableLoading, setTableLoading] = React.useState(false)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [paymentId, setPaymentId] = React.useState(null)
  const [courierList, setCourierList] = React.useState<Courier[]>([])
  const [payments, setPayments] = React.useState([])
  const [partnerPayments, setPartnerPayments] = React.useState([])
  const [filters, setFilters] = React.useState({
    courier_id: 'null',
  })
  const [showModal, setShowModal] = React.useState(false)
  React.useEffect(() => {
    fetchAllCouriers()
  }, [])
  const { showPageLoader, hidePageLoader, showSuccess, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const breadcrumbs = [
    {
      name: 'Payment Invoices',
      active: true,
    },
  ]
  const columns = [
    {
      dataKey: 'courier_name',
      name: 'Courier',
      width: '9%',
      sortable: true,
      selector: (row) => row.courier_name || '--',
    },
    {
      dataKey: 'invoice_name',
      name: 'Invoice Name',
      width: '19%',

      sortable: true,
      selector: (row) => row.invoice_name || '--',
    },
    {
      dataKey: 'invoice_reference',
      name: 'Invoice Reference',
      width: '14%',
      sortable: true,
      selector: (row) => row.invoice_reference || '--',
    },

    {
      dataKey: 'ems_load_date',
      name: 'Upload Date',
      width: '12%',
      sortable: true,
      selector: (row) => row.ems_load_date || '--',
    },
    {
      dataKey: 'invoice_amount',
      name: 'Invoice Amount',
      width: '14%',
      sortable: true,
      selector: (row) => row.invoice_amount || '--',
    },
    {
      dataKey: 'uploaded_by',
      name: 'Uploaded By',
      width: '14%',
      sortable: true,
      selector: (row) => row.uploaded_by || '--',
    },
    {
      dataKey: 'status',
      name: 'Status',
      width: '10%',
      sortable: true,
      selector: (row) => (
        <DcTag
          customBackgroundColor={
            row.status === 'paid'
              ? $DCSuccessLightColor
              : row.status === 'unpaid'
              ? $DCDangerLightColor
              : $DCInfoLightColor
          }
          textColor={
            row.status === 'paid'
              ? $DCSuccessColor
              : row.status === 'unpaid'
              ? $DCDangerColor
              : $DCInfoColor
          }
        >
          {row.status}
        </DcTag>
      ),
    },
    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => (
        <PixelFlexBox gap="15px">
          <PixelIcon
            color={'red'}
            showTooltip
            tooltip="Delete"
            icon={faTrash}
            onClick={() => {
              pixelConfirm({
                title: 'Payment Invoices',
                message: 'Are you sure you want to delete?',
                onConfirm: () => {
                  showPageLoader()
                  del(
                    `/courier/payments/${row.weekly_payment_header_id}`,
                  ).subscribe((res: AjaxResponse<IResponse | any>) => {
                    hidePageLoader()
                    const responseData = res.response as IResponse
                    if (responseData?.message) {
                      const updatedPayment = payments.filter(
                        (item) => item.id !== row.id,
                      )
                      showSuccess(`${responseData.message}`)
                      setPayments(updatedPayment)
                    } else {
                      showSuccess(`${responseData.error}`)
                    }
                  })
                },
              })
            }}
          />
        </PixelFlexBox>
      ),
    },
  ]
  const pColumns = [
    {
      dataKey: 'id',
      name: 'Id',
      width: '9%',

      sortable: true,
      selector: (row) => row.id || '--',
    },
    {
      dataKey: 'courier_name',
      name: 'Courier',
      width: '9%',
      sortable: true,
      selector: () => 'RSL',
    },
    {
      dataKey: 'invoice_period_start',
      name: 'Billing Period',
      selector: (row) =>
        (
          <PixelFlexBox>
            <PixelDate value={row.invoice_period_start?.date} /> -
            <PixelDate value={row.invoice_period_end?.date} />
          </PixelFlexBox>
        ) || '--',
    },
    {
      dataKey: 'date',
      name: 'Due Date',
      selector: (row) =>
        <PixelDate value={row.billing_invoice_due_date?.date} /> || '--',
    },
    {
      dataKey: 'created_at',
      name: 'Generated On',
      selector: (row) => <PixelDate value={row?.created_at?.date} /> || '--',
    },
    {
      dataKey: 'billing_invoice_status',
      name: 'Status',
      selector: (row) => (
        // <PixelTag>{row.billing_invoice_status || '--'}</PixelTag> || '--',
        <DcTag
          customBackgroundColor={
            row.billing_invoice_status === 'paid'
              ? $DCSuccessLightColor
              : row.billing_invoice_status === 'unpaid'
              ? $DCDangerLightColor
              : $DCInfoLightColor
          }
          textColor={
            row.billing_invoice_status === 'paid'
              ? $DCSuccessColor
              : row.billing_invoice_status === 'unpaid'
              ? $DCDangerColor
              : $DCInfoColor
          }
        >
          {row.billing_invoice_status}
        </DcTag>
      ),
    },
    {
      dataKey: 'billing_invoice_total',
      name: '₨ Amounts',
      selector: (row) =>
        (
          <PixelCurrency hideSymbol={false} value={row.billing_invoice_total} />
        ) || '--',
    },

    {
      dataKey: 'actions',
      name: 'Actions',
      sortable: true,
      style: {
        'div:first-child': {
          overflow: 'visible !important',
        },
      },
      selector: (row) =>
        row.status !== 'Updated!' ? (
          <PixelFlexBox>
            <PixelTableAction row={row} action={printInvoice()} />
          </PixelFlexBox>
        ) : (
          '--'
        ),
    },
  ]

  const printInvoice = () => [
    {
      title: 'Print Invoice',
      icon: (
        <>
          <Section>
            <PixelIcon icon={faPrint} />
          </Section>
        </>
      ),
      clickHandler: (row) => {
        window.open(`${row?.billing_invoice?.attachment_path}`)
      },
    },
  ]

  const fetchAllCouriers = () => {
    getGeneralCourierList().subscribe((res) => {
      const response = res.response as { data: Courier[] }
      setCourierList(response.data)
    })
  }
  React.useEffect(() => {
    getAllCourierPayments()
    getAllCourierPartnerPayments()
  }, [filters])

  const getAllCourierPayments = () => {
    setTableLoading(true)
    getCourierPayments(filters).subscribe((res) => {
      const response = res.response as { data: IWeeklyPayment[] }
      setPayments(response.data)
      setTableLoading(false)
    })
  }
  const getAllCourierPartnerPayments = () => {
    setTableLoading(true)
    getCourierPartnerPayments(filters).subscribe((res) => {
      const response = res.response as { data: IWeeklyPayment[] }
      setPartnerPayments(response.data)
      setTableLoading(false)
    })
  }
  const tenantData = localStorage.getItem('tenant_info')
  const tenant = JSON.parse(tenantData || '{}')
  const isPartner = tenant.is_partner
  const refferalCode = tenant.refferal_code

  const onRowClicked = (row) => {
    setPaymentId(row.id)
    setShowDetailModal(true)
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer
        style={{ height: 'calc(100vh - 100px)' }}
        padding="0 0 0 0"
      >
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              justifyContent="space-between"
              alignItems="flex-end"
              padding="0px 20px"
            >
              <DcTabs
                size="md"
                variant="simple"
                tabs={[
                  {
                    courier_name: 'All Couriers',
                    courier_id: 'null',
                  },
                  ...courierList,
                ].map((courier: any) => {
                  return {
                    label: courier.courier_name,
                    value: courier.courier_id,
                  }
                })}
                activeTab={filters.courier_id}
                handleChange={(value) => {
                  setFilters({
                    ...filters,
                    courier_id: value,
                  })
                }}
              />
              <DcButton
                margin="5px 0 5px 0"
                size="sm"
                onClick={() => setShowModal(true)}
                withIcon={true}
              >
                <UploadIcon size={16} /> <span>Upload Invoice</span>
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
        >
          <SectionContent>
            {isPartner == '1' &&
            refferalCode != 'null' &&
            courierList[0]?.courier_name == 'RSL' ? (
              <>
                <PixelTable
                  columns={pColumns}
                  data={partnerPayments}
                  progressPending={tableLoading}
                  onRowClicked={onRowClicked}
                  fixedHeader
                  fixedHeaderScrollHeight="calc(100vh - 220px)"
                />
              </>
            ) : (
              <>
                <PixelTable
                  columns={columns}
                  data={payments}
                  progressPending={tableLoading}
                  onRowClicked={onRowClicked}
                  fixedHeader
                  fixedHeaderScrollHeight="calc(100vh - 220px)"
                />
              </>
            )}
          </SectionContent>
        </Section>
      </PixelPageContainer>

      <DcOverlaySlider
        width={showModal ? '40%' : '70%'}
        title="Payment Invoices"
        onClose={() => setShowDetailModal(false)}
        isOpen={showDetailModal}
        padding="0px"
      >
        <PaymentInvoicesDetail
          payment_id={paymentId}
          setShowDetailModal={setShowDetailModal}
        />
      </DcOverlaySlider>
      {showModal && (
        <UploadPaymentInvoice
          show={showModal}
          courierList={courierList}
          handleClose={() => {
            setShowModal(false)
            getAllCourierPayments()
          }}
        />
      )}
    </>
  )
}

export default UploadPayments
